import { Container, Typography } from "@material-ui/core"
import { AiImage, postAiImageAiImageHistory } from "api"
import { Desktop, Mobile } from "common/MediaQueries"
import GenericButton from "components/GenericButton/GenericButton"
import SingleButtonSelection from "components/Reusable/Bit/SingleButtonSelection"
import Image from "next/image"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import styled from "styled-components"
import colors from "theme/colors"
import { useCreateAiContext } from "./CreateAiContext"
import CreatePictureAiButton from "./CreatePictureAiButton"

const StyledDesktopWrapper = styled(Container)`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    padding-top: 120px;
    justify-content: space-between;
    align-items: flex-start;
  }
`
const StyledContainer = styled.div`
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-top: 100px;
  }
`
const StyledTitle = styled(Typography).attrs({
  component: "h1",
  variant: "h1",
})`
  color: ${colors.black};
  white-space: nowrap;
  font-size: 40px;
  line-height: 0.6;
  font-family: Speedee, NarkisBlock, sans-serif;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`
const StyledContent = styled.div`
  margin-bottom: 30px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 40px;
  }
`
const StyledExplanation = styled(Typography).attrs({
  variant: "body1",
})`
  font-size: 20px;
  font-weight: 100;
  color: #000;
  line-height: 1.2;
  text-align: right;
`

const StyledChoosePictureContent = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
  gap: 16px;
  margin-bottom: 16px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 24px;
  }
`
const StyledImageWrapper = styled.div`
  aspect-ratio: 400 / 442;
  width: 100%;
  position: relative;

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 442px;
  }
`
const StyledChoosePicture = styled(Typography).attrs({
  variant: "body1",
})`
  font-size: 20px;
  font-weight: 400;
  font-family: "NarkisBlock", sans-serif;
  color: #000;
  line-height: 1.2;
  text-align: right;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 26px;
  }
`
const StyledInfo = styled(Typography).attrs({
  variant: "body2",
})`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${colors.black};
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 18px;
  }
`
const StyledChoosenPicturesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 30px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 40px;
  }
`

const StyledChoosenPicture = styled.label<{ $isSelected?: boolean }>`
  opacity: 0.5;
  img {
    border-radius: 8px;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 120px;
    height: 101px;
    margin-left: 16px;
    cursor: pointer;
    &:hover {
      border: solid 1px ${colors.black};
      border-radius: 8px;
      padding: 2px;
      opacity: 1;
    }
  }
  width: 76px;
  height: 64px;
  position: relative;
  margin-left: 8px;
  ${(p) =>
    p.$isSelected &&
    `
border:solid 1px ${colors.black};
border-radius:8px;
padding:2px;
opacity:1;
`}
`

const StyledNewPicture = styled.div`
  border-radius: 8px;
  border: dashed 1px ${colors.darkGrey};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 76px;
  height: 64px;

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 120px;
    height: 101px;
    cursor: pointer;
  }
`

const StyledNewPictureText = styled(Typography).attrs({
  variant: "body1",
})`
  font-size: 14px;
  font-weight: 100;
  color: #000;
  line-height: 1.2;
  text-align: right;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 18px;
  }
`

const ChoosePictureAiPage = () => {
  const { responseImageUrl, sessionId, setResponseImageUrl, limitAiImages } =
    useCreateAiContext()
  const [responseImages, setResponseImages] = useState<AiImage[]>()

  useEffect(() => {
    const getHistoryImages = async () => {
      const res = await postAiImageAiImageHistory({
        sessionId: sessionId,
      })
      setResponseImages(res.data.body)
    }
    getHistoryImages()
  }, [])
  const router = useRouter()

  const renderImage = (radioId: string, isSelected: boolean, index: number) => {
    return (
      <>
        <StyledChoosenPicture htmlFor={radioId} $isSelected={isSelected}>
          <Image
            objectFit="cover"
            objectPosition="top"
            src={responseImages[index].url}
            alt=""
            width={isSelected ? 114 : 120}
            height={isSelected ? 95 : 101}
          />
        </StyledChoosenPicture>
      </>
    )
  }

  const setPictures = (code) => {
    const selectedImage = responseImages?.find((b) => b.url === code)
    setResponseImageUrl(selectedImage.url)
  }

  const submitAiCard = () => {
    if (!responseImageUrl) {
      return
    }
    localStorage.setItem(
      "imageAiGuid",
      JSON.stringify(
        responseImages?.find((b) => b.url === responseImageUrl)?.imageGuid
      )
    )
    localStorage.setItem(
      "imageAiUrl",
      JSON.stringify(
        responseImages?.find((b) => b.url === responseImageUrl)?.url
      )
    )
    localStorage.setItem(
      "slugAi",
      JSON.stringify(
        responseImages?.find((b) => b.url === responseImageUrl)?.blessingSlug
      )
    )
    router.push(`/giftcard/${JSON.parse(localStorage.getItem("slugAi"))}`)
  }

  const renderResponsesImages = () => {
    return (
      <>
        <StyledChoosePictureContent>
          <StyledChoosePicture>איזו תמונה אהבת?</StyledChoosePicture>
          <StyledInfo>
            <Image
              src="/img/icons/infoIcon.svg"
              width={20}
              height={20}
              alt="info-icon"
            />
            ניתן לייצר עד 4 תמונות{" "}
          </StyledInfo>
        </StyledChoosePictureContent>
        {responseImages?.length > 0 ? (
          <StyledChoosenPicturesWrapper>
            <SingleButtonSelection
              id="amount"
              items={responseImages?.map((background) => ({
                value: background.url,
                name: background.imageGuid,
              }))}
              onSelect={(code) => setPictures(code)}
              gap={15}
              itemsPerRow={"auto"}
              selectedValue={responseImageUrl}
              customButton={(radioId, isSelected, item, index) =>
                renderImage(radioId, isSelected, index)
              }
            />
            {responseImages?.length < limitAiImages &&
              responseImages?.length > 0 && (
                <StyledNewPicture onClick={() => router.push("/create-ai")}>
                  <Image width={33} height={33} src="/img/aiIcon.svg" />
                  <StyledNewPictureText>תמונה חדשה</StyledNewPictureText>
                </StyledNewPicture>
              )}
          </StyledChoosenPicturesWrapper>
        ) : (
          <></>
        )}
      </>
    )
  }
  return (
    <StyledDesktopWrapper>
      <StyledContainer>
        <StyledContent>
          <StyledTitle>נו, איך יצא?</StyledTitle>
          <StyledExplanation>זו התמונה שה-AI יצר לך</StyledExplanation>
        </StyledContent>
        <Desktop>
          {renderResponsesImages()}

          <GenericButton onClick={submitAiCard} btnType="filled">
            סיימתי לבחור, הלאה
          </GenericButton>
        </Desktop>
        <Mobile>
          <StyledImageWrapper>
            <Image src={responseImageUrl} layout="fill" alt="ai-icon" />
          </StyledImageWrapper>
        </Mobile>

        <Mobile>{renderResponsesImages()}</Mobile>
      </StyledContainer>
      <Desktop>
        <StyledImageWrapper>
          <Image src={responseImageUrl} layout="fill" alt="ai-icon" />
        </StyledImageWrapper>
      </Desktop>

      <Mobile>
        <CreatePictureAiButton
          enabledButton={true}
          text={"סיימתי לבחור, הלאה"}
          submit={submitAiCard}
        />
      </Mobile>
    </StyledDesktopWrapper>
  )
}

export default ChoosePictureAiPage
